import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import ErrorTagIcon from 'assets/images/ErrorTagIcon.svg';

type ErrorOptionProps = {
  error: string;
};

const ErrorOptionRoot = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

const ErrorOptionIcon = styled('div')(({ theme }) => ({
  height: theme.spacing(24),
}));

export const ErrorOption = ({ error }: ErrorOptionProps) => {
  return (
    <ErrorOptionRoot>
      <Typography variant="text1" color="red.600">
        {error}
      </Typography>
      <ErrorOptionIcon>
        <ErrorTagIcon />
      </ErrorOptionIcon>
    </ErrorOptionRoot>
  );
};
